import axiosClient from 'utils/axiosClient';
import api from 'api';
import {formData} from 'utils/helpers/formData';

// A new upload is a File (antd wraps it in `originFileObj`); a stored image is its path or {path}.
const isNewUpload = (item: any) => item instanceof File || !!item?.originFileObj;
const toPath = (item: any) => (typeof item === 'string' ? item : item?.path);

// The gallery field is sent as repeated `gallery` parts — a raw file per new
// upload and a URL string per kept image — not the indexed `gallery[0][...]`
// object serialization the generic formData helper produces for file arrays.
// The kept images come from the upload field (window.existingFiles: the stored ones
// minus those deleted in the form), since a touched field's value holds only new uploads.
const buildEventFormData = (data: any, type?: 'ADD' | 'EDIT') => {
	const {gallery, ...rest} = data || {};
	const bodyFormData = formData(rest, type);
	const items = Array.isArray(gallery) ? gallery : [];
	const kept = Array.isArray(window.existingFiles)
		? window.existingFiles
		: items.filter((item: any) => !isNewUpload(item));

	kept.map(toPath)
		.filter(Boolean)
		.forEach((path: string) => bodyFormData.append('gallery', path));
	items
		.filter(isNewUpload)
		.forEach((item: any) => bodyFormData.append('gallery', item.originFileObj ?? item));

	return bodyFormData;
};

const getEvents = async (params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.EVENTS.EVENTS, {params});
	return response.data;
};

const getEventByID = async (id: any, params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.EVENTS.EVENT_BY_ID + id + '?detail=true', {
		...params
	});
	return response.data;
};

const createEvent = async (data: any) => {
	const response = await axiosClient.post(api.CAREER_CENTER.EVENTS.EVENTS, buildEventFormData(data, 'ADD'));
	return response.data;
};

const updateEvent = async (id: any, data: any) => {
	const response = await axiosClient.patch(
		api.CAREER_CENTER.EVENTS.EVENT_BY_ID + id,
		buildEventFormData(data)
	);
	return response.data;
};

const deleteEvents = async (ids: any) => {
	const response = await axiosClient.delete(api.CAREER_CENTER.EVENTS.EVENTS_BY_IDS + ids);
	return response.data;
};

const getRegistrantByID = async (studentID: any, params?: any) => {
	const response = await axiosClient.get(api.CAREER_CENTER.EVENTS.REGISTRANT_BY_STUDENT_ID + studentID, {
		params
	});
	return response.data;
};

const markRegistrantAttendance = async (registrationID: any, attended: boolean) => {
	const response = await axiosClient.patch(
		api.CAREER_CENTER.EVENTS.REGISTRATION_ATTENDANCE + registrationID + '/attendance',
		{attended}
	);
	return response.data;
};

// The registration status is a path param, not a body field:
// PATCH /api/careerCenter/events/registrations/:registrationID/status/:statusID
const updateRegistrationStatus = async (registrationID: any, statusID: any) => {
	const response = await axiosClient.patch(
		api.CAREER_CENTER.EVENTS.REGISTRATION_STATUS + registrationID + '/status/' + statusID
	);
	return response.data;
};

const service = {
	getEvents,
	getEventByID,
	createEvent,
	updateEvent,
	deleteEvents,
	getRegistrantByID,
	markRegistrantAttendance,
	updateRegistrationStatus
};

export default service;
